<template>
  <div class="print-container">
    <div v-if="loading" class="loading-message">
      Loading order details...
    </div>
    <div v-else-if="error" class="error-message">
       {{ error }}...
    </div>
 
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    tableName: {
      type: String,
      required: true
    },
    appId: {
      type: [String, Number],
      required: true
    },
    branchId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      loading: true,
      error: null,
      order: null,
      orderId: null,
      orderItems: [],
      table_name: null,
      oredrType: null,
      selectedOrderTotal: null,
      ordernet: null,
      table: null,
      orderNote: null,
      firstvalue: null,
      secondvalue: null,
      tax: 0,
      netTotal: 0,
      grandTotal: 0,
      addressDetails: {
        area: '',
        street: '',
        build: '',
        floor: '',
        flat: ''
      }
    };
  },
  async mounted() {
    await this.fetchTableAndOrder();
    await this.printOrder();
  },
  methods: {
     formatNumberWithCommas(num) {
  if (num === undefined || num === null) return '0.00';
  return parseFloat(num).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
},
    checkItemsBeforeAction() {
      // Add any validation logic here if needed
      return true;
    },
    async fetchTableAndOrder() {
      try {
        const token = localStorage.getItem('authToken');
        // First fetch table and basic order info
        const tableResponse = await axios.get(
          `${this.$BASE_API_URL}/api/tables/by-name/${this.$route.params.tableId}/${this.$route.params.appId}/${this.$route.params.branchId}`,
          {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          }
        );

        this.table = tableResponse.data.data.table;
        this.order = tableResponse.data.data.order;
        
        if (!this.order) {
          this.error = 'No active order found for this table';
          this.loading = false;
          return;
        }

        this.orderId = this.order.id;

        // Now fetch full order details
        const orderResponse = await axios.get(
          `${this.$BASE_API_URL}/api/externalorders/${this.orderId}`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            }
          }
        );

        const orderData = orderResponse.data.data;
        this.table_name = orderData.table_name;
        this.oredrType = orderData.type;
        this.selectedOrderTotal = parseFloat(orderData.grand_total);
        this.ordernet = parseFloat(orderData.net_total);
        this.orderNote = orderData.note;
        this.tax = parseFloat(orderData.tax_amount || 0);
        this.netTotal = this.ordernet;
        this.grandTotal = this.selectedOrderTotal;

        // Process order items
        this.orderItems = orderData.products.map(product => ({
          id: product.id,
          name: product.name || `Product ${product.id}`,
          price: parseFloat(product.pivot.price),
          basePrice: parseFloat(product.pivot.price),
          quantity: product.pivot.count,
          customizations: [], // You may need to populate this from your API
          note: product.pivot.note || '',
          taxes: [] // You may need to populate this from your API
        }));

        this.addressDetails = {
          area: orderData.area,
          street: orderData.street,
          build: orderData.build,
          floor: orderData.floor,
          flat: orderData.flat
        };

      } finally {
        this.loading = false;
      }
    },
    
    async printOrder() {
  if (!this.checkItemsBeforeAction()) return;
  
  // Helper function to format numbers with thousand separators
  const formatNumberWithCommas = (num) => {
    if (num === undefined || num === null) return '0.00';
    return parseFloat(num).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  };

  try {
    const token = localStorage.getItem('authToken');
    const orderId = this.orderId;
    const branchName = localStorage.getItem('branchName') || 'Silicon Oasis, Dubai-UAE';
    
    // First fetch the order details to check for a link
    const orderResponse = await axios.get(
      `${this.$BASE_API_URL}/api/externalorders/${orderId}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
    
    const order = orderResponse.data.data;
    const hasLink = order.link && order.link.trim() !== '';
    const isPaid = order.isPaid || 0;
    
    // Mark order as printed via API
    // await axios.put(
    //   `${this.$BASE_API_URL}/api/orders/${orderId}/print`,
    //   {}, 
    //   {
    //     headers: {
    //       'Content-Type': 'application/json',
    //       'Authorization': `Bearer ${token}`
    //     }
    //   }
    // );

    // Determine order type text
    let orderTypeText = '';
    switch(this.oredrType) {
      case 1: orderTypeText = 'Delivery Order'; break;
      case 2: orderTypeText = 'Dine-In Order'; break;
      case 3: orderTypeText = 'Takeaway Order'; break;
      default: orderTypeText = 'Order';
    }

    // Generate printable HTML with proper number alignment
    const printContent = `
  <html>
    <head>
      <title>Order Invoice</title>
      <style>
        body { font-family: Arial, sans-serif; margin: 0; padding: 20px; }
        .invoice-container { max-width: 800px; margin: 0 auto; }
        .header { display: flex; flex-direction: column; align-items: center; margin-bottom: 20px; border-bottom: 1px solid #eee; padding-bottom: 20px; }
        .logo { height: 80px; margin-bottom: 10px; }
        .header-text { text-align: center; }
        h1 { margin: 0 0 5px 0; color: #333; text-align: center; }
        .order-type { font-size: 1.2em; font-weight: bold; margin-bottom: 10px; color: #E3655B; text-align: center; }
        .invoice-info { display: flex; justify-content: space-between; margin-bottom: 20px; }
        table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
        th, td { border: 1px solid; padding: 12px; }
        th { background-color: #f2f2f2; font-weight: bold; }
        .total-row { font-weight: bold; }
        .footer { margin-top: 10px; padding-top: 20px; border-top: 1px solid #eee; font-size: 12px; text-align: center; color: #666; }
        .footer p { margin: 5px 0; }
        .note { margin-top: 20px; padding: 10px; background-color: #f9f9f9; border-left: 4px solid #E3655B; }
        .qr-container { text-align: center; margin: 20px 0; }
        .qr-code { width: 120px; height: 120px; margin: 10px auto; }
        .payment-button, .print-button {
          padding: 12px 24px;
          border: none;
          border-radius: 4px;
          font-size: 16px;
          cursor: pointer;
          text-decoration: none;
          display: inline-block;
          text-align: center;
        }
        .payment-button {
          background-color: #4CAF50;
          color: white;
        }
        .payment-button:hover {
          background-color: #45a049;
        }
        .print-button {
          background-color: #2196F3;
          color: white;
        }
        .print-button:hover {
          background-color: #0b7dda;
        }
        /* Number alignment styles */
        .text-left { text-align: left; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .action-buttons {
          display: flex;
          justify-content: center;
          gap: 20px;
          margin: 30px 0;
        }
      </style>
    </head>
    <body>
      <div class="invoice-container">
        <div class="header">
          <img class="logo" src="${this.$BASE_API_URL}/files/HOME.png" alt="Restaurant Logo">
          <div class="header-text">
            <h1>Restaurant Invoice</h1>
            <div class="order-type">${orderTypeText}</div>
            <p>${branchName}</p>
          </div>
        </div>
        
        <div class="invoice-info">
          <div>
            <p><strong>Invoice #:</strong> ${orderId || 'N/A'}</p>
            ${this.oredrType === 2 ? `<p><strong>Table #:</strong> ${this.table.name || 'N/A'}</p>` : ''}
            ${this.oredrType === 1 ? `
              <div>
                <p><strong>Delivery Address:</strong></p>
                <p>${this.addressDetails.area} ${this.addressDetails.street}</p>
                <p>Building: ${this.addressDetails.build}</p>
                <p>Floor: ${this.addressDetails.floor}, Flat: ${this.addressDetails.flat}</p>
              </div>
            ` : ''}
          </div>
          <div>
            <p><strong>Date:</strong> ${new Date().toLocaleDateString()}</p>
            <p><strong>Time:</strong> ${new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</p>
          </div>
        </div>
        
        <table>
          <thead>
            <tr>
              <th class="text-left">Item</th>
              <th class="text-center">Qty</th>
              <th class="text-right">Price (AED)</th>
              <th class="text-right">Total (AED)</th>
            </tr>
          </thead>
          <tbody>
            ${this.orderItems.map(item => `
              <tr>
                <td class="text-left">
                  ${item.name}
                  ${item.note ? `<div class="note">Note: ${item.note}</div>` : ''}
                  ${item.customizations.length > 0 ? `
                    <div style="font-size: 0.9em; color: #666;">
                      ${item.customizations.map(c => `${c.name}: ${c.option}`).join(', ')}
                    </div>
                  ` : ''}
                </td>
                <td class="text-center">${item.quantity}</td>
                <td class="text-right">${formatNumberWithCommas(item.price)}</td>
                <td class="text-right">${formatNumberWithCommas(item.price * item.quantity)}</td>
              </tr>
            `).join('')}
            <tr class="total-row">
              <td colspan="3" class="text-right">Subtotal:</td>
              <td class="text-right">${formatNumberWithCommas(this.netTotal)}</td>
            </tr>
            <tr class="total-row">
              <td colspan="3" class="text-right">Tax:</td>
              <td class="text-right">${formatNumberWithCommas(this.grandTotal - this.netTotal)}</td>
            </tr>
            ${this.firstvalue ? `
            <tr>
              <td colspan="3" class="text-right">Discount (Fixed):</td>
              <td class="text-right">-${formatNumberWithCommas(this.firstvalue)}</td>
            </tr>
            ` : ''}
            ${this.secondvalue ? `
            <tr>
              <td colspan="3" class="text-right">Discount (${this.secondvalue}%):</td>
              <td class="text-right">-${formatNumberWithCommas(this.netTotal * this.secondvalue/100)}</td>
            </tr>
            ` : ''}
            <tr class="total-row">
              <td colspan="3" class="text-right">Grand Total:</td>
              <td class="text-right">${formatNumberWithCommas(this.grandTotal)}</td>
            </tr>
          </tbody>
        </table>

        ${hasLink ? `
          <div class="qr-container">
               <p style="font-size: 12px;">Scan this QR code to view location</p>
            <img class="qr-code" 
                 src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(order.link)}" 
                 alt="Location QR Code">
          </div>
        ` : ''}
        ${this.orderNote ? `
        <div style="margin-top: 20px;">
          <h4>Order Notes:</h4>
          <p>${this.orderNote}</p>
        </div>
        ` : ''}
        <div class="action-buttons">
          ${isPaid === 0 ? `
            <a href="/viamenu/payment-page/${orderId}?amount=${this.grandTotal}" class="payment-button" target="_blank">
              Pay Now (AED ${formatNumberWithCommas(this.grandTotal)})
            </a>
          ` : ''}
        </div>
        <div class="footer">
          <p>Printed: ${new Date().toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
          }).replace(',', '')}</p>
          <p>Office# 311, SIT Tower, Silicon Oasis, Dubai-UAE, P.O.Box: 6847</p>
          <p>Phone: +971 4 320 7442 | Email: sales@unifi-me.com</p>
          <p>www.unifi-me.com</p>
        </div>
      </div>
    </body>
  </html>
`;
    // Save invoice to database
    // await axios.post(
    //   `${this.$BASE_API_URL}/api/orders/reports/save-invoice`,
    //   {
    //     orderId: orderId,
    //     content: printContent 
    //   },
    //   {
    //     headers: {
    //       'Content-Type': 'application/json',
    //       'Authorization': `Bearer ${token}`
    //     }
    //   }
    // );
    
    // Open invoice in new window without automatic printing
  document.open();
document.write(printContent);
document.close();
    
    this.$toast.success('Invoice generated successfully');

  } catch (error) {
    console.error('Error:', error);
    // this.$toast.error(error.response?.data?.message || 'Failed to generate invoice');
  }
}
  }
};
</script>

<style scoped>
.print-container {
  padding: 20px;
  text-align: center;
}
.loading-message, .error-message {
  margin: 20px 0;
  font-size: 18px;
  color: #fff;
}
/* .error-message {
  color: red;
} */
.print-button {
  padding: 10px 20px;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}
.print-button:hover {
  background-color: #3aa876;
}
</style>